<!-- eslint-disable max-len -->
<template>
  <div @click="toggleBackground" class="virtual-tour__show-btn">
    <svg xmlns="http://www.w3.org/2000/svg" height="50px" width="40px" viewBox="0 -960 960 960"  fill="#FFFFFF">
      <path v-if="!visibility" d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z"/>
      <path v-if="visibility" d="m644-428-58-58q9-47-27-88t-93-32l-58-58q17-8 34.5-12t37.5-4q75 0 127.5 52.5T660-500q0 20-4 37.5T644-428Zm128 126-58-56q38-29 67.5-63.5T832-500q-50-101-143.5-160.5T480-720q-29 0-57 4t-55 12l-62-62q41-17 84-25.5t90-8.5q151 0 269 83.5T920-500q-23 59-60.5 109.5T772-302Zm20 246L624-222q-35 11-70.5 16.5T480-200q-151 0-269-83.5T40-500q21-53 53-98.5t73-81.5L56-792l56-56 736 736-56 56ZM222-624q-29 26-53 57t-41 67q50 101 143.5 160.5T480-280q20 0 39-2.5t39-5.5l-36-38q-11 3-21 4.5t-21 1.5q-75 0-127.5-52.5T300-500q0-11 1.5-21t4.5-21l-84-82Zm319 93Zm-151 75Z"/>
    </svg>
  </div>
  <div :class="['virtual-tour__section', { 'backdrop': !bg }]">
    <!-- eslint-disable max-len -->
    <div class="custom-bg js-custom-tour-bg" v-if="bg">
      <img :src="`${cmsURL}assets/${bg}`" />
    </div>

    <div class="virtual-tour__title text-center">
      <h2 class="title js-title">
        {{ data.headline }}
      </h2>
      <h5 class="title title--small js-subtitle" v-if="data.description">
        {{ data.description }}
      </h5>
    </div>

    <template v-if="data.media_items">
      <template v-if="data.media_items.length < 2">
        <Media v-for="(item, index) in data.media_items" class="js-media-wrapper" :key="index" :poster="item.poster"
          :src="item.source" :title="data.media_caption" :type="item.type">
          <template v-slot:content>
            <div class="content" v-html="data.media_content"></div>
          </template>
        </Media>
      </template>
      <template v-else>
        <div class="media-gallery">
          <Media v-for="(item, index) in data.media_items" :class="['js-media-wrapper', `js-media-wrapper--${index}`,
            { 'active': index === 0 }]" :key="index" :poster="item.poster" :src="item.source" :title="data.media_caption"
            :type="item.type">
            <template v-slot:content>
              <div class="content" v-html="data.media_content"></div>
            </template>
          </Media>

          <div class="media-gallery__thumbs">
            <a v-for="(item, index) in data.media_items" :class="['single-thumb', 'js-media-nav',
              { 'active': index === 0 }]" href="javascript:void(0)" :key="index"
              @click="changeImg(`${index}`, $event.target)">
              <img :alt="data.media_caption" class="img-fluid object-fit-cover-center"
                :src="(item.type === 'video') ? item.poster : item.source" />
            </a>
          </div>
        </div>
      </template>
    </template>
    <template v-else>
      <div class="text-only">
        <h4 class="title" v-if="data.media_caption">
          {{ data.media_caption }}
        </h4>

        <div v-html="data.media_content"></div>
      </div>
    </template>
  </div>
</template>

<script>
import $ from 'jquery';
import { gsap } from 'gsap';

import * as endpoints from '@/common/endpoints';
import { defaultMixins } from '@/common/mixins';
import { showElement } from '@/common/animations';

import Media from '@/components/ui/Media.vue';

export default {
  name: 'TourSection',
  mixins: [defaultMixins],
  components: {
    Media,
  },
  props: {
    bg: String,
    data: Object,
  },
  data() {
    return {
      cmsURL: endpoints.CMS,
      visibility: true,
    };
  },
  mounted() {
    gsap.timeline()
      .add(showElement('.js-title', 'top'))
      .add(showElement('.js-subtitle', 'top'));
    gsap.timeline().add(showElement('.js-media-wrapper', 'top'));
  },
  methods: {
    changeImg(target, _this) {
      const video = document.getElementsByTagName('video');

      if (video.length > 0) {
        for (let index = 0; index < video.length; index += 1) {
          video[index].pause();
        }
      }

      $('.js-media-nav').removeClass('active');
      $(_this).parent().addClass('active');

      $('.js-media-wrapper').hide().removeClass('active');
      $(`.js-media-wrapper--${target}`).fadeIn().addClass('active');
    },
    toggleBackground() {
      const bgElement = document.querySelector('.virtual-tour__section');
      if (bgElement) {
        if (this.visibility === false) {
          bgElement.style.display = 'block';
          gsap.to('.virtual-tour__section', {
            opacity: 1,
            duration: 0.3,
          });
          this.visibility = true;
        } else {
          gsap.to('.virtual-tour__section', {
            opacity: 0,
            duration: 0.3,
            onComplete: () => {
              bgElement.style.display = 'none';
            },
          });
          this.visibility = false;
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/scss/views/virtual-tour/sections.scss';
</style>
